import { TablePaginationConfig } from "antd";
import { tripRequestsApi } from "api/tripRequest";
import { useDataLoadingContext } from "contexts/DataLoadingContext";
import { useNotificationContext } from "contexts/NotificationContext";
import { ITableData, defaultTableData } from "models";
import { ITripRequest } from "models/tripRequest";
import { ChangeEvent, useEffect, useState } from "react";
import moment from "moment";

export default function useTripRequest() {
  const { showError } = useNotificationContext();
  const { reloadTripRequest } = useDataLoadingContext();
  const [data, setData] = useState<ITableData<ITripRequest>>({
    ...defaultTableData,
    per_page: 10,
  });

  const [statusFilter, setStatusFilter] = useState<string>("all");
  const [dateFilter, setDateFilter] = useState<string>(moment().format("YYYY-MM-DD"));

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line
  }, [data.page, data.search, statusFilter, dateFilter, reloadTripRequest]);

  const fetchData = async () => {
    setData((prev) => ({ ...prev, loading: true }));
    const { data: response, error } = await tripRequestsApi(
      data.page,
      data.per_page,
      data.search,
      statusFilter,
      dateFilter
    );
    if (response) {
      // Log statuses to verify what we're getting
      const statuses = response.data.map((item) => item.status);
      const uniqueStatuses = Array.from(new Set(statuses));
      console.log("📊 Trip Request Statuses in response:", uniqueStatuses);
      console.log("📊 Total trip requests:", response.data.length);
      console.log("📊 Declined count:", response.data.filter((item) => item.status?.toLowerCase() === "declined").length);
      console.log("📊 Canceled/Cancelled count:", response.data.filter((item) =>
        item.status?.toLowerCase() === "canceled" || item.status?.toLowerCase() === "cancelled"
      ).length);

      response.data = response.data.map((value) => ({
        ...value,
        key: value.id,
      }));
      setData((prev) => ({ ...prev, ...response }));
    } else showError(error!.message);
    setData((prev) => ({ ...prev, loading: false }));
  };

  const handlePageChange = ({ current }: TablePaginationConfig) => {
    if (current) setData((prev) => ({ ...prev, page: current }));
  };

  const handleSearch = ({
    target: { value },
  }: ChangeEvent<HTMLInputElement>) => {
    setData((prev) => ({ ...prev, search: value ?? "", page: 1 }));
  };

  const handleStatusChange = (status: string) => {
    setStatusFilter(status);
    setData((prev) => ({ ...prev, page: 1 })); // reset page to 1 on tab change
  };

  const handleDateChange = (date: string) => {
    setDateFilter(date);
    setData((prev) => ({ ...prev, page: 1 }));
  };

  return { data, statusFilter, dateFilter, handlePageChange, handleSearch, handleStatusChange, handleDateChange };
}
